import { useSelector } from 'react-redux'

import {
  selectWelcomeVideoId,
  selectWelcomeVideoType,
  selectShouldDisplayWelcomeVideo
} from '../store/selectors/videos'

import {
  selectCustomMailerAudience,
  selectCustomMailerVideoId,
  selectCustomMailerVideoType,
  selectShouldDisplayEmailVideo
} from '../store/selectors/customMailer'

import { VIDEO_AUDIENCE } from '../constants/videos'

function useOpeningVideo() {
  const displayEmailVideo = useSelector(selectShouldDisplayEmailVideo)
  const emailVideoAudience = useSelector(selectCustomMailerAudience)
  const emailVideoId = useSelector(selectCustomMailerVideoId)
  const emailVideoType = useSelector(selectCustomMailerVideoType)

  const displayWelcomeVideo = useSelector(selectShouldDisplayWelcomeVideo)
  const welcomeVideoAudience = VIDEO_AUDIENCE.HOMEOWNERS
  const welcomeVideoId = useSelector(selectWelcomeVideoId)
  const welcomeVideoType = useSelector(selectWelcomeVideoType)

  const videoType = displayEmailVideo ? emailVideoType : welcomeVideoType
  const videoId = displayEmailVideo ? emailVideoId : welcomeVideoId
  const audience = displayEmailVideo ? emailVideoAudience : welcomeVideoAudience

  return {
    displayEmailVideo,
    displayWelcomeVideo,
    videoType,
    videoId,
    audience
  }
}

export { useOpeningVideo }
